// @core/api/endpoints/project/list_boards.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBoardsResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List boards
 * Returns all boards configured for the project, allowing users to switch between different board views.
 */
export async function ListBoards(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListBoardsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/boards`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListBoardsResponse>(requestPath, { ...requestOptions, params });
}
